// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city-15"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M13 3V9.83333L9 9V21H3V3H13Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill1","fill":"transparent","d":"M21 21V11.5L13 9.83333L9 9V21H21Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M15 17V21M13 9.83333V3H3V21H9V9L13 9.83333Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 21V11.5L13 9.83333L9 9V21H21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city-15')
export default class City15Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-15',
    }
  }
}
